// make sure these names are unique
export const Locations = [
  { name: "New York City", position: { x: 260, y: 210 } },
  { name: "London", position: { x: 545, y: 140 } },
  { name: "Hong Kong", position: { x: 1025, y: 300 } },
  { name: "Cayman Islands", position: { x: 220, y: 320 } },
  { name: "Dubai", position: { x: 770, y: 290 } },
  { name: "Lagos", position: { x: 560, y: 390 } },
  { name: "Sydney", position: { x: 1140, y: 620 } },
  { name: "Moscow", position: { x: 680, y: 130 } },
  { name: "Los Angeles", position: { x: 75, y: 220 } },
];
